module.exports = "<p>\n  modals works!\n</p>\n"